export default __webpack_public_path__ + "static/media/salesChannels.4ca412b8.svg";